<template>
  <b-tooltip label="Dar de alta al paciente" type="is-dark">
    <b-button type="is-primary" size="is-small" icon-left="user-times" @click="ConfirmUnassign" :loading="isLoading">
    </b-button>
  </b-tooltip>
</template>
<script>
  import { PutBedhistory } from "../../services/bedHistory";
  import { eventBus } from "../../main";
  import { GetBed, PutBed } from "../../services/beds";
  import moment from "moment";
  export default {
    props: ["bed"],
    data() {
      return {
        isLoading: false,
      };
    },
    methods: {
      ConfirmUnassign() {
        console.log(this.bed.id);
        this.$buefy.dialog.confirm({
          title: "Dar de alta a paciente",
          message: `¿Está seguro de querer dar de alta al paciente?`,
          confirmText: "Dar de alta",
          type: "is-success",
          hasIcon: true,
          onConfirm: () => {
            this.$buefy.dialog.prompt({
              message: `Ingresar fecha del alta`,
              inputAttrs: {
                type: "date",
                value: moment().format("YYYY-MM-DD")
              },
              confirmText: "Confirmar",
              trapFocus: true,
              onConfirm: async (value) => {
                this.isLoading = true;
                try {
                  let currentBed = await GetBed(this.$http, this.bed.id);
                  let lastBedHistory = currentBed.beds_histories[currentBed.beds_histories.length - 1];
                  await PutBedhistory(this.$http, lastBedHistory.id, {
                    ...lastBedHistory,
                    leave_date: value,
                  });
                  let dataBed = {
                    ...this.bed,
                    covid19:'no',
                    ventilator_used:'no',                  
                    patient_id: null,
                  };
                  await PutBed(this.$http, this.bed.id, dataBed);
                  eventBus.$emit("loadBedList");
                  this.toast("El paciente se ha dado de alta", "is-success");
                } catch (error) {
                  console.log(error);
                  this.toast("Lo sentimos, ha ocurrido un error", "is-danger");
                }
                this.isLoading = false;
              },
            });
          },
        });
      },
    },
  };
</script>